import * as types from './types';

export const setSelectedTab = payload => ({
  type: types.SET_ACCOUNT_MODAL_SELECTED_TAB,
  payload
});

export const setTemporaryMessage = payload => ({
  type: types.SET_ACCOUNT_MODAL_TEMPORARY_MESSAGE,
  payload
});

export const signInIsLoading = () => ({
  type: types.SIGN_IN_IS_LOADING
});

export const signInError = error => ({
  type: types.SET_SIGN_IN_ERROR,
  payload: error
});

export const setAccountModalEmail = email => ({
  type: types.SET_ACCOUNT_MODAL_EMAIL,
  payload: email
});

export const createUserIsLoading = () => ({
  type: types.CREATE_USER_IS_LOADING
});

export const createUserError = error => ({
  type: types.SET_CREATE_USER_ERROR,
  payload: error
});

export const clearCreateUserError = () => ({ type: types.CLEAR_CREATE_USER_ERROR });

export const createUserSuccess = () => ({
  type: types.CREATE_USER_SUCCESS
});

export const forgotPasswordIsLoading = () => ({
  type: types.FORGOT_PASSWORD_IS_LOADING
});

export const forgotPasswordSuccess = () => ({
  type: types.FORGOT_PASSWORD_SUCCESS
});

export const forgotPasswordError = error => ({
  type: types.SET_FORGOT_PASSWORD_ERROR,
  payload: error
});

export const clearForgotPasswordState = () => ({
  type: types.CLEAR_FORGOT_PASSWORD_STATE
});

export const resetPasswordIsLoading = () => ({
  type: types.RESET_PASSWORD_IS_LOADING
});

export const resetPasswordSuccess = () => ({
  type: types.RESET_PASSWORD_SUCCESS
});

export const resetPasswordError = error => ({
  type: types.SET_RESET_PASSWORD_ERROR,
  payload: error
});

export const clearResetPasswordState = () => ({
  type: types.CLEAR_RESET_PASSWORD_STATE
});

export const setResetPasswordToken = oneUseToken => ({
  type: types.SET_RESET_PASSWORD_TOKEN,
  payload: oneUseToken
});
